__turbopack_context__.v({
  "address": "DonateModal-module__HyAioG__address",
  "copy": "DonateModal-module__HyAioG__copy",
  "copyIcon": "DonateModal-module__HyAioG__copyIcon",
  "currency": "DonateModal-module__HyAioG__currency",
  "currencyContainer": "DonateModal-module__HyAioG__currencyContainer",
  "qrCode": "DonateModal-module__HyAioG__qrCode",
  "qrContainer": "DonateModal-module__HyAioG__qrContainer",
  "root": "DonateModal-module__HyAioG__root",
});
